import 'react-lazy-load-image-component/src/effects/blur.css'

import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import bmwNewLogo from 'images/bmw-logo-new.png'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Carousel } from 'react-bootstrap'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { IVehicleImage } from 'types/vehicleTypes'

import { StyledVehicleDetailsGridCardImage } from './VehicleDetailsGridCardImage.styled'
import { SliderContext } from 'contexts/SliderContext'

interface IProps {
  images: IVehicleImage[]
  vehicleInstanceID: number
  isDSI?: boolean
}

interface IImage extends IVehicleImage {
  CanLoad: boolean
}

export const VehicleDetailsGridCardImage = ({ images, vehicleInstanceID, isDSI = false }: IProps) => {
  const { setDisplaySlider, setSliderData, selectedImageID, selectedVehicle, showCarousel } = useContext(SliderContext)
  const [canLoadImage, setCanLoadImage] = useState<boolean>(true)
  const [activeIndex, setActiveIndex] = useState<number>(0)
  const imgList = useMemo<IImage[]>(
    () => images?.map((img) => ({ ...img, CanLoad: true, Description: isDSI ? '' : img.Description })),
    [images]
  )
  useEffect(() => {
    if (selectedImageID && showCarousel && selectedVehicle === vehicleInstanceID) {
      let imgIndex = imgList.findIndex((x) => x.ID === selectedImageID)
      setActiveIndex(imgIndex === -1 ? 0 : imgIndex)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedImageID, imgList])

  const handleSelect = (selectedIndex: number) => {
    setActiveIndex(selectedIndex)

    setCanLoadImage(imgList[selectedIndex].CanLoad)
  }

  const handleBrokenImageURL = (id: number) => {
    imgList.find((img) => img.ID === id).CanLoad = false
    setCanLoadImage(false)
  }

  if (!imgList || imgList.length === 0) {
    return (
      <StyledVehicleDetailsGridCardImage className="w-100">
        {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
        <img src={bmwNewLogo} className="img-err" alt="No Image" />
      </StyledVehicleDetailsGridCardImage>
    )
  }

  return (
    <StyledVehicleDetailsGridCardImage className="w-100">
      {imgList?.length > 1 ? (
        <>
          <span className="page-indicator pill">{`${activeIndex + 1} / ${imgList.length}`}</span>
          <Carousel
            className={classNames('w-100', { 'img-load-err': !canLoadImage })}
            interval={null}
            indicators={false}
            nextIcon={<FontAwesomeIcon icon={faChevronRight} size="2x" />}
            prevIcon={<FontAwesomeIcon icon={faChevronLeft} size="2x" />}
            activeIndex={activeIndex}
            onSelect={handleSelect}
          >
            {imgList.map((img, idx) => (
              <Carousel.Item key={idx}>
                <LazyLoadImage
                  src={img.CanLoad ? img.LocalThumbImageURL || img.ImageURL : bmwNewLogo}
                  alt={img.Description}
                  className={classNames({ 'img-err': !canLoadImage })}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null
                    handleBrokenImageURL(img.ID)
                  }}
                  onClick={() => {
                    if (canLoadImage) {
                      setSliderData(imgList)
                      setDisplaySlider(!!img.ImageURL, imgList[activeIndex].ID, vehicleInstanceID)
                    }
                  }}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        </>
      ) : (
        <LazyLoadImage
          className={classNames('w-100', { 'img-load-err': !canLoadImage })}
          src={imgList[0].CanLoad ? imgList[0].LocalThumbImageURL || imgList[0].ImageURL : bmwNewLogo}
          alt={imgList[0].Description}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null
            handleBrokenImageURL(imgList[0].ID)
          }}
          onClick={() => {
            if (canLoadImage) {
              setSliderData(imgList)
              setDisplaySlider(!!imgList[0].ImageURL, imgList[0].ID, vehicleInstanceID)
            }
          }}
        />
      )}
    </StyledVehicleDetailsGridCardImage>
  )
}
